import {
  Button,
  ButtonVariant,
  ColorClass,
  Icon,
  IconIdentifier,
} from '@aus-platform/design-system';
import { useAppSelector } from 'src/app/hooks';
import { selectMap3dDataset } from 'src/map-3d/shared/map-3d-slices';
import { TERRAIN_CLEANUP_GENERATING_STRINGS } from './constants';

type GeneratingOutput = {
  setIsGeneratingCleanup: (state: boolean) => void;
};

export const TerrainCleanupGenerating: React.FC<GeneratingOutput> = ({
  setIsGeneratingCleanup,
}) => {
  const { selectedTerrainIteration } = useAppSelector(selectMap3dDataset);
  const { site: siteId, id: iterationId } = selectedTerrainIteration || {};

  const goToIteration = () => {
    const newTab = window.open(
      `/iterations?siteId=${siteId}&iterationId=${iterationId}`,
      '_blank',
    );
    newTab?.focus();
  };

  return (
    <div className="generating-cleanup">
      <Icon
        className="generating-cleanup__loading-icon"
        identifier={IconIdentifier.Cleanup}
        size={78}
        colorClass={ColorClass.Primary500}
      />
      <div className="generating-cleanup__text">
        <strong>{TERRAIN_CLEANUP_GENERATING_STRINGS.TITLE}</strong>
        <p>{TERRAIN_CLEANUP_GENERATING_STRINGS.DESCRIPTION}</p>
      </div>
      <Button
        onClick={goToIteration}
        className="generating-cleanup__open-iterations-btn"
      >
        {TERRAIN_CLEANUP_GENERATING_STRINGS.OPEN_ITERATIONS_BUTTON}
      </Button>
      <Button
        onClick={() => setIsGeneratingCleanup(false)}
        variant={ButtonVariant.Link}
      >
        {TERRAIN_CLEANUP_GENERATING_STRINGS.GENERATE_NEW_BUTTON}
      </Button>
    </div>
  );
};
